import { emptyList } from '@constants/empty';
import { getDay, getMonthString, getYear } from '@utils/dates';

const oneDay = 24 * 60 * 60 * 1000;

export const getBatchTag = (batch = {}) => {
  const { syllabusTag, allTopicsCovered } = batch;
  const tag = allTopicsCovered ? 'Full syllabus' : 'Partial Syllabus';
  return syllabusTag || tag;
};

export const getDateInfo = (startAt, endAt) => {
  if (!startAt) return null;
  const start = new Date(startAt).setHours(0, 0, 0, 0);
  const end = endAt && new Date(endAt).setHours(0, 0, 0, 0);
  const current = new Date().setHours(0, 0, 0, 0);
  const startText = `${getDay(startAt)} ${getMonthString(startAt)} ${getYear(
    startAt
  )}`;
  const endText =
    endAt && `${getDay(endAt)} ${getMonthString(endAt)} ${getYear(endAt)}`;
  let dateInfo = '';
  if (start >= current) {
    const diff = Math.ceil((start - current) / oneDay);
    if (diff < 1) {
      dateInfo = `Starts today · ${startText}`;
    } else if (diff < 2) {
      dateInfo = `Starts tomorrow · ${startText}`;
    } else if (diff > 1 && diff < 8) {
      dateInfo = `Starts in ${diff} days · ${startText}`;
    } else {
      dateInfo = `Starts on ${startText}`;
    }
  } else if (start < current && (!end || current < end)) {
    dateInfo = `Started on ${startText}`;
  } else {
    dateInfo = `Ended on ${endText}`;
  }
  return dateInfo;
};

export const authorsInfo = (firstUser, batchAuthors) => {
  const firstUserName = firstUser?.name;
  const authorsNameArr =
    batchAuthors?.map((author) => author.name) || emptyList;

  if (firstUserName) {
    if (authorsNameArr.length) {
      const index = authorsNameArr.indexOf(firstUserName);
      authorsNameArr.splice(index, 1);
      authorsNameArr.splice(0, 0, firstUserName);
    } else {
      return firstUserName;
    }
  }

  if (authorsNameArr.length) {
    if (authorsNameArr.length < 2) {
      return authorsNameArr[0];
    }
    if (authorsNameArr.length > 1 && authorsNameArr.length < 4) {
      return `${authorsNameArr
        .slice(0, -1)
        .join(', ')} and ${authorsNameArr.slice(-1)}`;
    }
    return `${authorsNameArr.slice(0, 3).join(', ')} and ${
      authorsNameArr.length - 3
    } more`;
  }
  return '';
};
